// extracted by mini-css-extract-plugin
export default {"desktop-wrapper":"DesktopWrapper_desktop-wrapper__15NA7"};